import styled from "@emotion/styled";
import { Heading } from "react-aria-components";

export const CustomDialogHeading = styled(Heading)`
  font-family: var(--font-family);

  /* Headlines (desktop)/Sub2 */
  font-size: 1.25rem /* 20/16 */;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 28px */
  letter-spacing: -0.025rem /* -0.4/16 */;

  height: 24px;
  margin-bottom: 8px;
`;
